<template>
  <v-app>
    <navigation :color="color" :flat="flat" />
    <v-main class="pt-0">
      <home />
      <!-- <about /> -->
      <!-- <download /> -->
      <!-- <pricing /> -->
      <contact />
    </v-main>
    <v-scale-transition>
      <v-btn
        fab
        v-show="fab"
        v-scroll="onScroll"
        dark
        fixed
        bottom
        right
        color="secondary"
        @click="toTop"
      >
        <v-icon>mdi-arrow-up</v-icon>
      </v-btn>
    </v-scale-transition>
    <foote />
  </v-app>
</template>

<style scoped>
.v-main {
  
  background-attachment: fixed;
  background-position: center;
  background-size: cover;
}
.notInUse{
  background-image: url("~@/assets/img/bgMain.png");
}

@font-face {
    font-family: 'Lastlap';
    src: url("~@/assets/fonts/Lastlap.otf");
}
</style>

<script>
import navigation from "./components/Navigation";
import foote from "./components/Footer";
import home from "./components/HomeSection";
import about from "./components/AboutSection";
import download from "./components/DownloadSection";
import pricing from "./components/PricingSection";
import contact from "./components/ContactSection";

export default {
  name: "App",
  metaInfo: {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Inicio',
      // all titles will be injected into this template
      titleTemplate: '%s | RMS Uy Solutions',
      htmlAttrs: {
        lang: 'es-UY'
      },
      meta:[
        { name: 'description', content: 'Explora la convergencia innovadora de mecánica, electrónica e informática en el mundo de la mecatrónica. Descubre soluciones ingeniosas para el futuro de tu compania.  ¿Cuánto tiempo esperarás antes de exigir lo mejor para tu empresa?' }
      ]
    },

  components: {
    navigation,
    foote,
    home,
    about,
    download,
    pricing,
    contact,
  },

  data: () => ({
    fab: null,
    color: "",
    flat: null,
  }),

  created() {
    const top = window.pageYOffset || 0;
    if (top <= 60) {
      this.color = "transparent";
      this.flat = true;
    }
  },

  watch: {
    fab(value) {
      if (value) {
        this.color = "secondary";
        this.flat = false;
      } else {
        this.color = "transparent";
        this.flat = true;
      }
    },
  },

  methods: {
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 60;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
  },
};
</script>
